export enum Envs {
    staging = 'staging',
    production = 'production'
}